window.unblockedScripts = JSON.parse(
  sessionStorage.getItem("scripts-unblocked")
);
function unblockAllScripts() {
  console.log("unblocking scripts");
  if (window.unblockedScripts?.unblocked) return;
  window.yett.unblock();
  sessionStorage.setItem(
    "scripts-unblocked",
    JSON.stringify({ unblocked: true })
  );
}

if (window.unblockedScripts?.unblocked) {
  console.log("unblocking scripts automatically");
  window.yett.unblock();
} else {
  //   const navBarScript = document.querySelector("#nav-bar-src")?.innerHTML;
  //   if (navBarScript) {
  //     const script = document.createElement("script");
  //     script.src = navBarScript;
  //     document.body.appendChild(script);
  //   }
  document.addEventListener("mouseenter", unblockAllScripts, {
    once: true,
  });

  document.addEventListener("touchmove", unblockAllScripts, {
    once: true,
  });
}
